export const getImagePath = (path: string) => {
    if (path.startsWith("http")) return getEnvStr(path);
    return getEnvStr(`{IMG_PREFIX}${path}`);
};

export const getBackendUrl = (path?: string) => {
    return getEnvStr(`{BACKEND_HOST}{BACKEND_PORT}{BACKEND_PREFIX}${path?.startsWith('/') ? '' : '/'}${path}`);
}

export const getEnvStr = (str: string) => {
    const env = process.env;
    if (!env) {
        console.error(".env is not exist")
        return str;
    }

    return env[`REACT_APP_${str}`] ??
        str.replace(/{([^}]+)}/g, (match, key) => env[`REACT_APP_${key}`] ?? match);
};

